export const AUTH_ROUTE_PREFIX = "/auth";

export const AUTH_ROUTE_PATHS = {
  login: { path: "*", to: AUTH_ROUTE_PREFIX },
};
